module.exports = __webpack_public_path__ + "static/media/icon_sort.e62a5b28.svg";